module.exports = __webpack_public_path__ + "img/es.15a3ea68.jpg";